export default __webpack_public_path__ + "static/media/client.d430ef2c.png";